<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<blockquote epub:type="epigraph" role="doc-epigraph">
<p class="LINESPACE" id="epi"> </p>
<p class="EP"><span aria-label="vii" id="pg_vii" role="doc-pagebreak">Pour your eternal dreams, samples of blood</span></p>
<p class="EP">From one glass to another.</p>
<p class="EPC">—Osip Mandelstam (translated by James Greene)</p>
<p class="EP1">The spider spins her web on dark days.</p>
<p class="EPC">—Proverb</p>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?7fd0c20a